import type { TOC } from '@ember/component/template-only'
import { StudentDashboardTile } from 'teacher-ui-client/components/tiles/student-dashboard'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { TaskState } from 'teacher-ui-client/components/task-state'
import { StudentDashboardSubheader } from 'teacher-ui-client/components/tiles/student-dashboard/subheader'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'
import { ComprehensionProgressOverview } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/comprehension-progress/overview'
import { ComprehensionProgressPlacementEventsDetailed } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/comprehension-progress/placement-events-detailed'
import { ComprehensionProgressEventsDetailed } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/comprehension-progress/events-detailed'

import type {
  ComprehensionProgressOverviewReportData,
  ComprehensionProgressEventsReportData,
} from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import type { Task } from 'ember-concurrency'

interface Args {
  fetchComprehensionProgressOverviewReportTask: Task<ComprehensionProgressOverviewReportData | undefined, unknown[]>
  fetchComprehensionProgressPlacementEventsReportTask: Task<
    ComprehensionProgressEventsReportData | undefined,
    unknown[]
  >
  fetchComprehensionProgressEventsReportTask: Task<ComprehensionProgressEventsReportData | undefined, unknown[]>
}

interface Signature {
  Args: Args
}
export const DashboardStudentComprehensionProgressPage: TOC<Signature> = <template>
  <StudentDashboardTile
    data-test-student-dashboard-tile="comprehension-lesson-progress"
    @theme={{themeKey "reading"}}
    @title={{t "pages.reporting.readingEggspress.dashboard.student.comprehensionLessons.title"}}
    @icon="phosphor-share-network-fill"
  >
    <TaskState
      @task={{@fetchComprehensionProgressOverviewReportTask}}
      @initialLoadingClass="m-3"
      as |lastValue isRunning|
    >
      <ComprehensionProgressOverview class="w-full" @overviewData={{lastValue.overview}} @isLoading={{isRunning}} />
    </TaskState>
    <StudentDashboardSubheader>
      {{t "pages.reporting.readingEggspress.dashboard.student.placementTest"}}
    </StudentDashboardSubheader>
    <TaskState
      @task={{@fetchComprehensionProgressPlacementEventsReportTask}}
      @initialLoadingClass="m-3"
      as |lastValue isRunning|
    >
      <ComprehensionProgressPlacementEventsDetailed
        class="w-full"
        @eventsData={{lastValue.events}}
        @isLoading={{isRunning}}
      />
    </TaskState>
    <StudentDashboardSubheader>
      {{t "pages.reporting.readingEggspress.dashboard.student.recentActivity"}}
    </StudentDashboardSubheader>
    <TaskState
      @task={{@fetchComprehensionProgressEventsReportTask}}
      @initialLoadingClass="m-3"
      as |lastValue isRunning|
    >
      <ComprehensionProgressEventsDetailed class="w-full" @eventsData={{lastValue.events}} @isLoading={{isRunning}} />
      <BasePageSelector
        class="my-4"
        @pageCount={{lastValue.meta.total_pages}}
        @itemCount={{lastValue.meta.total_entries}}
      />
    </TaskState>
  </StudentDashboardTile>
</template>

export default DashboardStudentComprehensionProgressPage
